import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedProduct } from 'contracts/Products';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_PRODUCTS_',
  }
);

export interface ListProductsState {
  data: ListedProduct[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListProductsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedProduct[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListProductsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListProductsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListProductsState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListProductsState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListProductsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listProducts = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListProductsTypes = Types;
export const ListProductsActions = Creators;
